import React from 'react'
import { connect } from 'react-redux'
import games from './betsolutions/assets/index'
import arrowIcon from '../assets/double-arrow.svg'

import { defineMessages, FormattedMessage } from 'react-intl'
import Loader from '../../../../shared/components/Loader.jsx'
import { openBetsolutionGameWindow } from '../../../../config/games'

const messages = defineMessages({
  new: {
    id: 'games.new',
    defaultMessage: 'Новинки',
  },
})

class NewGames extends React.Component {
  state = {
    loading: false,
  }

  clickBetsolution = (game) => {
    this.setState({ loading: true })

    if (this.props.gamblerId) {
      fetch(`/api/games-betsolutions/`)
        .then((r) => r.json())
        .then(({token}) => {
          this.loadGame(game, token)
        })
    } else {
      if (game.productId === 2) {
        this.loadGame(game)
      } else {
        this.props.dispatch({ type: 'BEGIN_SIGNIN' })
        this.setState({ loading: false })
      }
    }
  }

  loadGame = (game, token) => {
    const config = {
      Token: token ? token : '54D2A7CA-FD87-46D4-A5A0-6BC0372C43EE',
      MerchantId: token ? 5096 : 105,
      GameId: game.id,
      ProductId: game.productId,
      IsFreeplay: 1,
      Lang: this.props.languageId === 5 ? 'en-US' : 'ru-RU',
      Platform: 'desktop',
      IframeContainerId: 'iframeContainer',
      IframeId: 'gameIFrame',
      GameOpenType: 'iframe',
      AuthUrl: token
        ? 'https://auth-ru.betsolutions.com/auth/auth/'
        : 'https://auth-tr.betsolutions.com/auth/auth/',
    }
    if (game.productId === 1) {
      config.TableGamesLobbyPageId = 1
      if (!token) {
        config.MerchantId = 34
        config.Token = '17B437DF-AB78-44CB-904F-621704BC610F'
      }
    }
    if (token) {
      config.IsFreeplay = 0
    }
    openBetsolutionGameWindow(config)
    this.setState({ loading: false })
  }

  render() {
    const { loading } = this.state
    const list = games.slice(0, 5)
    return (
      <div className="banner">
        {loading && <Loader />}
        <div className="banner--title">
          <FormattedMessage {...messages.new} />
          <img src={arrowIcon} alt="" />
        </div>
        {list.map((g) => (
          <div
            key={g.id}
            className="tdn"
            onClick={() => this.clickBetsolution(g)}
          >
            <Item className="banner--title" {...g} />
          </div>
        ))}
      </div>
    )
  }
}

export default connect((state) => {
  const user = state.auth.get('user')
  return {
    gamblerId: user && user.get('gamblerId'),
    languageId: state.application.get('languageId'),
  }
})(NewGames)

function Item({ img, name }) {
  return (
    <div className="banner_item" title={name}>
      <div className="banner_item--img">
        <img src={img} alt={name} />
      </div>
      <div className="banner_item--label">{name}</div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/games/slots/NewGamesBanner.jsx